<div class="row m-2">
    <ng-template [ngTemplateOutlet]="combobox" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="combobox" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="dropdownlist" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="dropdownlist" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="multiselect" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="multiselect" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>

<!--Combobox-->
<ng-template #combobox let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Combobox
            </span>
            <kendo-combobox class="w-100" [valuePrimitive]="false" [itemDisabled]="itemDisabled"
                [data]="assessmentTypes" [textField]="'name'" [valueField]="'id'" [disabled]="disabled"
                [(ngModel)]="selectedType">
            </kendo-combobox>
        </label>
    </div>
</ng-template>

<!--Dropdown list-->
<ng-template #dropdownlist let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Dropdown List
            </span>
            <kendo-dropdownlist id="preferredLanguage" [data]="languages" [textField]="'displayName'"
                [valueField]="'id'" [valuePrimitive]="true" [disabled]="disabled" [(ngModel)]="selectedPreferred">
            </kendo-dropdownlist>
        </label>
    </div>
</ng-template>

<!--Multi Select-->
<ng-template #multiselect let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Multi Select
            </span>
            <kendo-multiselect id="languages" [data]="languages" [textField]="'displayName'" [filterable]="false"
                [valueField]="'id'" [autoClose]="true" [virtual]="virtualLanguage" [disabled]="disabled"
                [(ngModel)]="selectedLanguage">
            </kendo-multiselect>
        </label>
    </div>
</ng-template>